export {};

let map: google.maps.Map;
let markers: google.maps.Marker[] = [];
let initCalled = false;
let MARKER_ICONS: MarkerIcons | null = null;
let mapContainer = document.getElementById("map")!;
let longitude = -71.64949;
let latitude = 48.549342;
let zoom = 6;
let currentOpenInfoWindow: google.maps.InfoWindow | null = null;
const STORES_LIST = JSON.parse(
  document.getElementById("stores-list")!.textContent!,
);

// Fonction pour initialiser les icônes des marqueurs
function initMarkerIcons() {
  const storeList = document.getElementById("store-list");
  if (!storeList) {
    console.error("Element #store-list not found");
    return;
  }
  if (
    !storeList.dataset.officialMarkerUrl ||
    !storeList.dataset.retailerMarkerUrl
  )
    return;
  MARKER_ICONS = {
    official: {
      url: storeList.dataset.officialMarkerUrl,
      scaledSize: new google.maps.Size(30, 30),
    },
    reseller: {
      url: storeList.dataset.retailerMarkerUrl,
      scaledSize: new google.maps.Size(30, 30),
    },
  };
}

function fitMapToQuebec() {
  latitude = 46.6787443;
  longitude = -72.7723292;
  zoom = 7;
}

// Fonction pour charger les locations depuis les données intégrées
async function loadLocations() {
  try {
    const locations = {
      officialStores: [] as StoreLocation[],
      resellers: [] as StoreLocation[],
    };

    STORES_LIST.forEach((store: Store) => {
      const location: StoreLocation = {
        name: store.name ? store.name : "",
        address: store.address ? store.address : "",
        city: store.city ? store.city : "",
        province: store.province ? store.province : "",
        country: store.country ? store.country : "",
        postalCode: store.postal ? store.postal : "",
        phone: store.phone ? store.phone : "",
        lat: store.latitude ? Number(store.latitude) : null,
        lng: store.longitude ? Number(store.longitude) : null,
        type: store.official_stores === "Y" ? "official" : "reseller",
      };

      // Vérifier si les coordonnées sont valides
      if (
        location.lat !== null &&
        location.lng !== null &&
        !isNaN(location.lat) &&
        !isNaN(location.lng)
      ) {
        if (location.type === "official") {
          locations.officialStores.push(location);
        } else {
          locations.resellers.push(location);
        }
      }
    });

    return locations;
  } catch (error) {
    console.error("Erreur lors du chargement des locations:", error);
    return { officialStores: [], resellers: [] };
  }
}

async function initMap() {
  if (initCalled) return;
  initCalled = true;

  // Initialiser les icônes des marqueurs
  initMarkerIcons();

  try {
    // Charger les locations depuis les données intégrées
    const locations = await loadLocations();

    // Masquer le loader une fois la carte initialisée
    const mapLoader = document.querySelector(".map-loader");
    if (mapLoader) {
      mapLoader.classList.add("hidden");
    }

    // Initialize the map centered on Quebec
    map = new google.maps.Map(mapContainer, {
      disableDefaultUI: true,
      center: { lat: latitude, lng: longitude }, // Centre sur Quebec
      zoom: zoom, // Zoom ajusté pour voir plus de la province
      styles: [
        {
          elementType: "geometry",
          stylers: [{ color: "#f5f5f5" }],
        },
        {
          elementType: "labels.icon",
          stylers: [{ visibility: "off" }],
        },
        {
          elementType: "labels.text.fill",
          stylers: [{ color: "#616161" }],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [{ color: "#f5f5f5" }],
        },
        {
          featureType: "administrative.land_parcel",
          elementType: "labels.text.fill",
          stylers: [{ color: "#bdbdbd" }],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [{ color: "#eeeeee" }],
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [{ color: "#757575" }],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [{ color: "#e5e5e5" }],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [{ color: "#9e9e9e" }],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [{ color: "#ffffff" }],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.text.fill",
          stylers: [{ color: "#757575" }],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [{ color: "#dadada" }],
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [{ color: "#616161" }],
        },
        {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [{ color: "#9e9e9e" }],
        },
        {
          featureType: "transit.line",
          elementType: "geometry",
          stylers: [{ color: "#e5e5e5" }],
        },
        {
          featureType: "transit.station",
          elementType: "geometry",
          stylers: [{ color: "#eeeeee" }],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [{ color: "#c9c9c9" }],
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [{ color: "#9e9e9e" }],
        },
      ],
    });

    // Créer les marqueurs pour toutes les locations
    locations.officialStores.forEach((location) => createMarker(location));
    locations.resellers.forEach((location) => createMarker(location));

    // Initialiser la liste des magasins
    initializeStoreList(locations);
  } catch (error) {
    console.error("Erreur lors de l'initialisation de la carte:", error);
  }
}

// Fonction pour créer un marqueur sur la carte
function createMarker(location: StoreLocation) {
  const marker = new google.maps.Marker({
    position: { lat: location.lat!, lng: location.lng! },
    map: map,
    title: location.name,
    icon:
      location.type && MARKER_ICONS ? MARKER_ICONS[location.type] : undefined,
    zIndex: location.type === "official" ? 2 : 1, // Les magasins officiels auront un zIndex plus élevé
    animation: google.maps.Animation.DROP,
  });

  const contentString = `
    <div class="info-window">
      <h3>${location.name}</h3>
      <p>${location.address}</p>
      <p>${location.city}, ${location.province} ${location.postalCode}</p>
      ${location.phone ? `<p>Tel: ${location.phone}</p>` : ""}
    </div>
  `;

  const infowindow = new google.maps.InfoWindow({
    content: contentString,
  });

  marker.addListener("click", () => {
    if (currentOpenInfoWindow) {
      currentOpenInfoWindow.close();
    }
    infowindow.open(map, marker);
    currentOpenInfoWindow = infowindow;
  });

  markers.push(marker);
}

function initializeStoreList(locations: {
  officialStores: StoreLocation[];
  resellers: StoreLocation[];
}) {
  const storeList = document.getElementById("store-list");
  const searchInput = document.getElementById("store-search");
  const allLocations = [...locations.officialStores, ...locations.resellers];

  // Fonction pour créer une section de magasins
  function createStoreSection(title: string) {
    const section = document.createElement("div");
    section.className = "store-section";

    const titleElement = document.createElement("h2");
    titleElement.textContent = title;
    section.appendChild(titleElement);

    return section;
  }

  // Fonction pour créer un élément de magasin
  function createStoreElement(location: StoreLocation) {
    const storeElement = document.createElement("div");
    storeElement.className = `store-item ${location.type}`;

    storeElement.innerHTML = `
      <h3>${location.name}</h3>
      <p>${location.address}</p>
      <p>${location.city}, ${location.province} ${location.postalCode}</p>
      ${location.phone ? `<p>Téléphone: ${location.phone}</p>` : ""}
    `;

    storeElement.addEventListener("click", () => {
      map.setCenter({ lat: location.lat!, lng: location.lng! });
      map.setZoom(15);

      const marker = markers.find(
        (m) =>
          m.getPosition()?.lat() === location.lat &&
          m.getPosition()?.lng() === location.lng,
      );

      // if (marker) {
      //   markers.forEach((m) => {
      //     if (m.infowindow) m.infowindow.close();
      //   });
      //   if (marker.infowindow) marker.infowindow.open(map, marker);
      // }
      // Infowindow est jamais attacher sur les markers
    });

    return storeElement;
  }

  // Fonction pour ajuster la carte aux marqueurs visibles
  function fitMapToVisibleMarkers(visibleLocations: StoreLocation[]) {
    if (visibleLocations.length === 0) return;

    const bounds = new google.maps.LatLngBounds();
    visibleLocations.forEach((location) => {
      bounds.extend({ lat: location.lat!, lng: location.lng! });
    });

    map.fitBounds(bounds, { top: 50, right: 50, bottom: 50, left: 50 });

    if (visibleLocations.length === 1) {
      setTimeout(() => {
        map.setZoom(10);
      }, 100);
    }
  }
  // Fonction pour calculer la distance entre deux points géographiques (Haversine formula)
  function calculateDistance(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number,
  ) {
    const R = 6371; // Rayon de la Terre en kilomètres
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  async function geocodePostalCode(postalCode: string) {
    // Nettoyer le code postal (enlever les espaces, mettre en majuscules)
    //const cleanPostalCode = postalCode.replace(/\s/g, '').toUpperCase();

    try {
      // Option 1: OpenStreetMap Nominatim (gratuit, pas de clé requise)
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?postalcode=${postalCode}&country=CA&format=json`,
      );
      const data = await response.json();

      if (data && data.length > 0) {
        return {
          latitude: parseFloat(data[0].lat),
          longitude: parseFloat(data[0].lon),
        };
      }
    } catch (error) {
      console.error("Erreur lors de la recherche par code postal:", error);
      alert("Une erreur est survenue lors de la recherche");
    }
  }

  // Fonction pour filtrer et afficher les magasins
  async function filterAndDisplayStores(searchTerm = "") {
    const maxDistance = 100;
    const cleanPostalCode = searchTerm.replace(/\s/g, "").toUpperCase();
    const postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

    let officialLabel = "Boutiques Officielles";
    let resellerLabel = "Points de Vente";
    if (document.documentElement.lang === "en") {
      officialLabel = "Official Stores";
      resellerLabel = "Retail Locations";
    }
    const searchTermLower = searchTerm.toLowerCase();
    const visibleLocations: StoreLocation[] = [];

    // Suppression des sections existantes
    document.querySelectorAll(".store-section").forEach((section) => {
      section.remove();
    });

    // Vérifier si le terme de recherche est un code postal
    if (postalCodeRegex.test(cleanPostalCode)) {
      try {
        geocodePostalCode(cleanPostalCode).then((geocodedLocation) => {
          console.log(geocodedLocation);
          if (!geocodedLocation) return;
          map.setCenter({
            lat: geocodedLocation.latitude!,
            lng: geocodedLocation.longitude!,
          });
          map.setZoom(10);
        });
      } catch (error) {
        console.error("Erreur lors de la recherche par code postal:", error);
        alert("Une erreur est survenue lors de la recherche");
      }
    } else {
      if (searchTerm === "") {
        // Affichage initial avec sections séparées
        const officialSection = createStoreSection(officialLabel);
        const resellerSection = createStoreSection(resellerLabel);

        locations.officialStores.forEach((location) => {
          officialSection.appendChild(createStoreElement(location));
          visibleLocations.push(location);
        });

        locations.resellers.forEach((location) => {
          resellerSection.appendChild(createStoreElement(location));
          visibleLocations.push(location);
        });

        storeList?.appendChild(officialSection);
        storeList?.appendChild(resellerSection);
      } else {
        // Affichage des résultats de recherche
        const matchingOfficial = locations.officialStores.filter(
          (location) =>
            location.city.toLowerCase().includes(searchTermLower) ||
            location.name.toLowerCase().includes(searchTermLower),
        );

        const matchingResellers = locations.resellers.filter(
          (location) =>
            location.city.toLowerCase().includes(searchTermLower) ||
            location.name.toLowerCase().includes(searchTermLower),
        );

        const allMatchingLocations = [
          ...matchingOfficial,
          ...matchingResellers,
        ];

        if (matchingOfficial.length > 0) {
          const officialSection = createStoreSection(officialLabel);
          matchingOfficial.forEach((location) => {
            officialSection.appendChild(createStoreElement(location));
            visibleLocations.push(location);
          });
          storeList?.appendChild(officialSection);
        }

        if (matchingResellers.length > 0) {
          const resellerSection = createStoreSection(resellerLabel);
          matchingResellers.forEach((location) => {
            resellerSection.appendChild(createStoreElement(location));
            visibleLocations.push(location);
          });
          storeList?.appendChild(resellerSection);
        }
      }
    }

    // Ajuster la carte pour montrer tous les résultats visibles
    if (searchTerm == "") {
      fitMapToQuebec();
    } else {
      fitMapToVisibleMarkers(visibleLocations);
    }
  }

  // Initialiser la liste avec tous les magasins
  filterAndDisplayStores();

  // Ajouter l'écouteur d'événements pour la recherche
  let searchTimeout: ReturnType<typeof setTimeout>;
  if (!searchInput) return;
  searchInput.addEventListener("input", async (e) => {
    const searchTerm = (e.target as HTMLInputElement).value.trim();

    if (searchTimeout) clearTimeout(searchTimeout);

    searchTimeout = setTimeout(async () => {
      try {
        await filterAndDisplayStores(searchTerm);
      } catch (error) {
        console.error("Erreur lors de la recherche:", error);
      }
    }, 300);
  });
}

// Exposer initMap globalement pour le callback de l'API Google Maps
window.initMap = initMap;
